import { render, staticRenderFns } from "./LongCard.vue?vue&type=template&id=44ec60e2&"
import script from "./LongCard.vue?vue&type=script&lang=js&"
export * from "./LongCard.vue?vue&type=script&lang=js&"
import style0 from "./LongCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports